<script>
export let text;
export let className = 'footnote';
</script>

<small class="{className}">{@html text}</small>
